<nb-card>
  <nb-card-header>
    <span i18n="@@AdditionalCertificates">Сертификаты</span>
    <button i18n-nbTooltip="@@Upload" (click)="showUploadForm = !showUploadForm" nbTooltip="Загрузить" nbButton status="control" size="small">
      <nb-icon icon="{{showUploadForm ? 'minus-outline' : 'plus-outline'}}"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body>
    <app-uploader *ngIf="showUploadForm" (upload)="onUpload($event)"/>

    <nb-list
      *ngIf="model?.certificates?.length"
      cdkDropList
      (cdkDropListDropped)="drop($event)"
      [cdkDropListData]="model.certificates">

      <nb-list-item
        *ngFor="let certificate of model.certificates"
        cdkDrag
        cdkDragLockAxis="y">

        <div class="pointer" (click)="download(certificate)">{{ certificate.header }}</div>

        <div class="float-end">
          <button type="button" size="small" status="control">
            <nb-icon
              i18n-nbTooltip="@@Delete"
              (click)="removeDialog(certificate)"
              nbTooltip="Удалить"
              icon="close-outline"/>
          </button>
        </div>
      </nb-list-item>
    </nb-list>
  </nb-card-body>
</nb-card>
